// extracted by css-extract-rspack-plugin
export default {"toggle":"ItemActionMenu-module__toggle__zfgx6"};